import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/**
 * `PUT /client/:cid/branches/:id/payment-fields`. The form's "payment provider" is stored as `acquirer_name`, the
 * field cb-client-admin-api wrote (its route refused the `payment_provider` key this form used to send).
 */
export const editPaymentFields = async (
  branch_id: string,
  merchant_id: string,
  acquirer_id: string,
  payment_provider: string
): Promise<any> => {
  await lpRequest('PUT', clientPath(`/branches/${branch_id}/payment-fields`), {
    body: { merchant_id, acquirer_id, acquirer_name: payment_provider }
  });

  return getBranch(branch_id);
};
